import { Button, Space } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Assign from './components/Assign';
import Delete from './components/Delete';
import Edit from './components/Edit';
import Options from './components/Options';

export interface ActionProps {
  onClick?: (...args: unknown[]) => unknown;
  disabled?: boolean;
  title?: string;
  tooltip?: string;
}

const ActionIcon = ({ children }: { children: React.ReactNode }) => {
  return (
    <Space size="small" className="actions">
      {children}
    </Space>
  );
};

export const WrapperAction = ({
  children,
  disabled,
  tooltip,
  onClick,
  title,
  ...props
}: {
  children: JSX.Element;
  disabled?: boolean;
  tooltip?: string;
  title?: string;
  onClick?: (...args: unknown[]) => unknown;
  [key: string]: unknown;
}) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Button
      title={t(title)}
      style={{ borderColor: 'rgba(255, 255, 255, 0.25)' }}
      className={classNames('flex items-center justify-center text-black dark:text-white', {
        'bg-[#ffffff14] fill-[#ffffff40] text-[#ffffff40]': disabled,
      })}
      size="small"
      ghost
      {...{ onClick, disabled, ...props }}
    >
      {children}
    </Button>
  );
};

ActionIcon.Assign = Assign;
ActionIcon.Edit = Edit;
ActionIcon.Delete = Delete;
ActionIcon.Options = Options;

export default ActionIcon;
